/* MM funnel v1.0.3 (30 Oct 2026): model_ready now means the first picture of the model on screen (the baked still,
   img.mm-pv-desk), on every device, timed from Generate. Before, it waited for the live 3D view (mm:live3d), which only
   fires on devices fast enough for it, so phones that fall back to the still were counted as lost. live3d is now its own step.
   MM funnel v1.0.2 (29 Oct 2026): header clicks counted on their own (hdr_btn = the black 'Build your place' button,
   hdr_menu = a header menu link to the designer). Before, a header click on the homepage counted as home_build.
   MM funnel v1.0.1 (28 Oct 2026). Where visitors drop off: one small beacon per page view to the mailer (Funnel.gs),
   one row per page view in the "Funnel" tab of MM Render Emails. Only sent when the visitor has allowed analytics
   in the cookie banner (Shopify Customer Privacy API). No personal data: a random id per browser tab, page type,
   source type, device type, country code, seconds, and the steps reached. Never what they typed, never an address.
   Reads the page only (clicks and two events the configurator already fires); changes nothing on the page. */
(function () {
  var cfg = window.MMF_CFG || {};
  if (!cfg.api || window.__mmfOn || navigator.webdriver) return;
  window.__mmfOn = 1;
  var T0 = Date.now(), ev = [], seen = {}, errs = 0, genAt = 0, genMs = 0, size = '', sentLen = -1;
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } return null; }
  var path = location.pathname;
  var page = path === '/' ? 'home' : /^\/pages\/configurator/.test(path) ? 'cfg' : /^\/products\//.test(path) ? 'product' : /^\/cart/.test(path) ? 'cart' : 'other';
  var id = ss('mmf_id');
  if (!id || !/^[a-z0-9]{8,24}$/.test(id)) { id = (Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-6)).replace(/[^a-z0-9]/g, 'x'); ss('mmf_id', id); }
  var land = ss('mmf_land') || (ss('mmf_land', page), page);
  var src = ss('mmf_src') || (function () {
    var q = location.search, r = document.referrer || '', s = 'other';
    if (/fbclid|utm_source=(fb|facebook|ig|instagram|meta)/i.test(q)) s = 'meta-ad';
    else if (/utm_|gclid|ttclid/i.test(q)) s = 'ad-other';
    else if (!r || r.indexOf(location.host) >= 0) s = 'direct';
    else if (/instagram/i.test(r)) s = 'instagram';
    else if (/facebook|fb\.com/i.test(r)) s = 'facebook';
    else if (/tiktok/i.test(r)) s = 'tiktok';
    else if (/google\./i.test(r)) s = 'google';
    else if (/bing\.|duckduckgo|yahoo\./i.test(r)) s = 'search-other';
    ss('mmf_src', s); return s;
  })();
  var n = (+(ss('mmf_n') || 0) || 0) + 1; ss('mmf_n', String(n));
  function hit(name, val) {
    if (seen[name]) return;
    seen[name] = 1;
    if (ev.length < 60) ev.push(name + '@' + Math.round((Date.now() - T0) / 1000) + (val ? '=' + val : ''));
  }
  if (page === 'home' || page === 'cfg') hit(page);

  // Shopify cookie banner: only send with analytics consent
  function allowed() { var c = window.Shopify && window.Shopify.customerPrivacy; try { return !!(c && c.analyticsProcessingAllowed && c.analyticsProcessingAllowed()); } catch (e) { return false; } }
  try { if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (e) {}

  function stepOf(el) {
    var card = el.closest && el.closest('.mm-step-card'), lab = card && card.querySelector('.mm-step-lab');
    var t = lab ? lab.textContent.toLowerCase() : '';
    return /size/.test(t) ? 'size' : /frame/.test(t) ? 'frame' : /colou?r|finish/.test(t) ? 'colour' : /label/.test(t) ? 'label' : /place/.test(t) ? 'place' : '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    try {
      if (t.closest('.mm-hcta')) hit('hdr_btn');
      else if (t.closest('#header-group a[href*="/pages/configurator"]')) hit('hdr_menu');
      else if (t.closest('.mmf-search__btn')) hit('home_build');
      else if (t.closest('.mmf-prompt')) hit('home_search');
      else if (page === 'home' && t.closest('a[href*="/pages/configurator"]')) hit('home_build');
      if (t.closest('.mm-area-next')) hit('place_done');
      var tile = t.closest('.mm-tile');
      if (tile) {
        var st = stepOf(tile);
        if (st === 'size') { var m = tile.textContent.match(/(\d{2})\s*cm/); size = m ? m[1] : size; hit('size', size); }
        else if (st && st !== 'place') hit(st);
      }
      var next = t.closest('.mm-step-next');
      if (next) { var s2 = stepOf(next); if (s2 && s2 !== 'place') hit(s2); }
      if (t.closest('.mm-cta')) { hit('generate'); if (!genAt) { genAt = Date.now(); watchModel(); } }
      if (t.closest('.mm-cancel')) hit('gen_cancel');
      if (t.closest('.mm-buy')) hit('add_to_cart');
      if (t.closest('.mm-back')) hit('adjust');
      if (t.closest('.mm-restart')) hit('restart');
      if (t.closest('.mm-cmp-btn')) hit('compare');
      if (t.closest('button[name="checkout"], a[href*="/checkout"], [data-mm-checkout]')) hit('checkout');
    } catch (x) {}
  }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('mmf-search__input')) hit('home_search');
    if (t.classList.contains('mm-search-input')) hit('place_search');
  }, true);
  document.addEventListener('submit', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('.mmf-search__input')) hit('home_build'); }, true);
  window.addEventListener('mm:pickspot', function () { hit('place_picked'); });
  window.addEventListener('mm:live3d', function () { hit('live3d'); });
  // v1.0.3: the model counts as seen when its first picture is on screen: a new src on img.mm-pv-desk that has loaded.
  var genPrev = '', genTimer = 0;
  function deskImg() { return document.querySelector('.mm img.mm-pv-desk') || document.querySelector('img.mm-pv-desk'); }
  function watchModel() {
    if (genTimer) return;
    var im0 = deskImg(); genPrev = im0 ? (im0.getAttribute('src') || '') : '';
    genTimer = setInterval(function () {
      try {
        var im = deskImg(), s = im ? (im.getAttribute('src') || '') : '';
        if (im && s && s !== genPrev && im.complete && im.naturalWidth > 0) { clearInterval(genTimer); if (!genMs) genMs = Date.now() - genAt; hit('model_ready'); }
        else if (Date.now() - genAt > 600000) clearInterval(genTimer);
      } catch (e) { clearInterval(genTimer); }
    }, 500);
  }
  window.addEventListener('error', function () { errs++; });
  window.addEventListener('unhandledrejection', function () { errs++; });

  // visitor's country from Shopify's privacy API (IP based); Shopify.country is the shop currency market they picked
  function region() { try { var c = window.Shopify && window.Shopify.customerPrivacy, g = c && c.getRegion && c.getRegion(); if (g) return String(g).slice(0, 2).toUpperCase(); } catch (e) {} return ((window.Shopify && window.Shopify.country) || '').slice(0, 2); }
  function send() {
    if (ev.length === sentLen || !allowed()) return;
    sentLen = ev.length;
    var p = { action: 'funnel', v: 1, id: id, n: n, page: page, land: land, src: src,
      dev: (window.matchMedia && matchMedia('(pointer:coarse)').matches) || innerWidth < 768 ? 'mobile' : 'desktop',
      cc: region(), secs: Math.round((Date.now() - T0) / 1000),
      ev: ev.join(' '), size: size, gen: genMs, err: errs, b: (window.MM_BUILDS && window.MM_BUILDS.configurator) || '' };
    try {
      var body = JSON.stringify(p);
      if (navigator.sendBeacon) navigator.sendBeacon(cfg.api, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      else fetch(cfg.api, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(); });
  window.addEventListener('pagehide', send);
  window.MMF = { state: function () { return { id: id, n: n, page: page, land: land, src: src, ev: ev.slice(), allowed: allowed(), size: size, gen: genMs, err: errs }; }, send: send };
})();